import Lightbox from "yet-another-react-lightbox";
import { FC } from "react";
import Download from "yet-another-react-lightbox/plugins/download";

interface Props {
  lightboxIndex: number;
  setLightboxIndex: React.Dispatch<React.SetStateAction<number>>;
  images: string[];
}

const LightBox: FC<Props> = ({ lightboxIndex, setLightboxIndex, images }) => {
  return (
    <Lightbox
      render={{
        iconNext: () => (
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
              fill="white"
              fillOpacity="0.35"
            />
            <path
              d="M25.5 35.3045L32 28.0001L25.5 20.6958"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        iconPrev: () => (
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56Z"
              fill="white"
              fillOpacity="0.35"
            />
            <path
              d="M30.5 35.3045L24 28.0001L30.5 20.6958"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
      }}
      styles={{
        root: {
          "--yarl__color_backdrop": "rgba(0, 0, 0, .25)",
          "--yarl__carousel_padding_px": 40,
        },
      }}
      open={lightboxIndex >= 0}
      close={() => setLightboxIndex(-1)}
      slides={images.map((image) => {
        return {
          src: image,
          download: `${image}`,
        };
      })}
      index={lightboxIndex}
      plugins={[Download]}
    />
  );
};

export default LightBox;
